/* eslint-disable  no-console */
import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { Composition } from './type'

export interface State {
    list: Composition[]
}

export default defineStore('deksoft', () => {
    const state: State = reactive({
        list: [],
    })

    const fetchList = async (ids:string[]) => {
        const response = await fetch('https://deksoft.eu/api/api-keys/anonymous?key=Tfzc24MvzrYhkB26e2LqJDxE&response=json')
        if (!response.ok) {
            console.error(response)
            return
        }

        const accessKey = (await response.json()).access_key

        ids.forEach((id: string, index: number) => {
            (async () => {
                const response = await fetch(`https://deksoft.eu/api/cbSkladby/${id}?access_key=${accessKey}&action=item&bim_config=178`)
                if (!response.ok) {
                    console.error(response)
                    return
                }

                const json = await response.json()
                const composition: Composition = {
                    name: json.nazev,
                    video: json.data_bim.CommonDEKSOFT.Video,
                    catalogue: json.data_bim.CommonDEKSOFT.Datasheet,
                    details: json.data_bim.CommonDEKSOFT.Details,
                    thermal: json.data_bim.CommonDEKSOFT.ThermalTransmittanceCalculation,
                    configurator: json.data_bim.CommonDEKSOFT.Calculation,
                    characteristic: json.popis,
                    usage: json.data_bim.CommonDEKSOFT.BuildingType,
                    image: json.other_data.images.map((element: { secret: string }) => {
                        return `https://deksoft.eu/api/image-library-file/${element.secret}?response=img`
                    }).shift(),
                    pdf: `https://deksoft.eu/api/bim-plugin/${id}?access_key=${accessKey}&action=skladbaPdfById`,
                    specifications: json.bim_materials.filter((element: { vazba: { web: number } }) => {
                        return element.vazba.web
                    }).map((element: { data: { nazev: string; plugin_data: { ALL_MODEL_URL: string } } }) => { //eslint-disable-line
                        return {
                            name: element.data.nazev,
                            url: element.data?.plugin_data?.ALL_MODEL_URL, //eslint-disable-line
                        }
                    }),
                }

                state.list.splice(index, 0, composition)
            })()
        })
    }

    const getList = () => state.list

    return {
        fetchList,
        getList,
    }
})
